import AccountContext from "common-components/dist/common/components/Account/context";

export default AccountContext;
